import { render, staticRenderFns } from "./wishingWall.vue?vue&type=template&id=b6eebbc2&scoped=true&"
import script from "./wishingWall.vue?vue&type=script&lang=js&"
export * from "./wishingWall.vue?vue&type=script&lang=js&"
import style0 from "./wishingWall.vue?vue&type=style&index=0&id=b6eebbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6eebbc2",
  null
  
)

export default component.exports